import { render, staticRenderFns } from "./grafik-kk.vue?vue&type=template&id=000f3f8d"
import script from "./grafik-kk.vue?vue&type=script&lang=js"
export * from "./grafik-kk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports